import { createSelector } from 'reselect'

const getState = state => state.AssessmentFile

const getFetchRequest = state => getState(state).fetchAssessmentFileRequest

const getAssessmentFile = state => getState(state).assessmentFile

const getContributors = state => getState(state).contributors

const getContributorsMap = createSelector(
  [getContributors],
  contributors => (!contributors ? {} : contributors.entities.contributors)
)

const getContributorsResult = createSelector(
  [getContributors],
  contributors => (!contributors ? [] : contributors.result)
)

const getContributorsList = createSelector(
  [getContributorsResult, getContributorsMap],
  (result, contributorsMap) => result.map(id => contributorsMap[id])
)

const getContributorsCount = createSelector(
  [getContributorsResult],
  result => result.length
)

const getContributor = (state, id) => getContributorsMap(state)[id]

const isInvitationModalOpen = state =>
  getState(state).invitationAssessmentDialog.opened

const getAssessmentFileId = state => getState(state).assessmentFile.id

const getAssessmentFileConclusionState = state =>
  getState(state).assessmentFile && getState(state).assessmentFile.concluded

const getAssessmentFileClosedState = state =>
  getState(state).assessmentFile && getState(state).assessmentFile.closed

const getFetchInvitationRequest = state =>
  state.Discussion.inviteContributorRequest

const getEditTitleDialog = state => getState(state).editTitleDialog

const getInviteesDialog = state => getState(state).inviteesDialog

const getInvitees = state => getState(state).invitees

const getInviteesMap = createSelector(
  [getInvitees],
  invitees => (!invitees ? {} : invitees.entities.invitees)
)

const getInviteesResult = createSelector(
  [getInvitees],
  invitees => (!invitees ? [] : invitees.result)
)

const getInviteesList = createSelector(
  [getInviteesResult, getInviteesMap],
  (result, inviteesMap) => result.map(id => inviteesMap[id])
)

const getInviteesCount = createSelector(
  [getInviteesResult],
  result => result.length
)

const fetchInviteesRequest = state => getState(state).fetchInviteesRequest

export {
  getFetchRequest,
  getAssessmentFile,
  getContributorsList,
  getContributorsCount,
  getContributor,
  isInvitationModalOpen,
  getAssessmentFileId,
  getAssessmentFileConclusionState,
  getFetchInvitationRequest,
  getEditTitleDialog,
  getAssessmentFileClosedState,
  getInviteesDialog,
  getInviteesList,
  getInviteesCount,
  fetchInviteesRequest
}
